/* globals console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    ResizeObserver = require('resize-observer-polyfill'),
    _ = require('lodash'),
    // models & collections
    Filters = require('../collections/filters'),
    Program = require('../models/program'),
    Programs = require('../collections/programs'),
    user = require('../models/user'),
    // views
    Console = require('./console'),
    ProgramDetails = require('./programDetails'),
    ProgramsHeaderFilter = require('./programsHeaderFilter'),
    ProgramsMap = require('./programsMap'),
    ProgramsSidebarFilter = require('./programsSidebarFilter'),
    ProgramsSummaries = require('./programsSummaries'),
    ShareDialog = require('./shareDialog'),
    // utilities
    jsoncrush = require('../libs/jsoncrush'),
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    helpers = require('../utilities/handlebars').helpers,
    RESIZE_DELTA = 20,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'programs row'
    },
    channels: {
        console: BackboneRadio.channel('console'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childViewEvents: {
        'details:closed':            'onDetailsClosed',
        'display:section':           'onDisplaySection',
        'filter:programs':           'onFilterPrograms',
        'group:cleared':             'onGroupCleared',
        'latitudeLongitude:updated': 'onLatitudeLongitudeUpdated',
        'next:program':              'onNextProgram',
        'popout':                    'onPopout',
        'previous:program':          'onPreviousProgram',
        'program:updated':           'onProgramUpdated',
        'programs:filtered':         'onProgramsFiltered',
        'select:program':            'onSelectProgram',
        'select:programId':          'onSelectProgramId',
        'jump:reports':              function (options) {this.trigger('jump:reports', options);},
        'share:programs':            'onSharePrograms',
        'sort:programs':             'onSortPrograms',
        'wizard:closed':             'onWizardClosed'
    },
    events: {
        'click button': 'onClickButton'
    },
    mobile: true,
    programs: undefined,
    regions: {
        console:               {el: 'div[name=console]',               replaceElement: true},
        programDetails:        {el: 'div[name=programDetails]',        replaceElement: true},
        programsHeaderFilter:  {el: 'div[name=programsHeaderFilter]',  replaceElement: true},
        programsMap:           {el: 'div[name=programsMap]',           replaceElement: true},
        programsSidebarFilter: {el: 'div[name=programsSidebarFilter]', replaceElement: true},
        programsSummaries:     {el: 'div[name=programsSummaries]',     replaceElement: true}
    },
    tagName: 'div',
    template: templates.programs,
    templateContext: function () {
        return {
            mobile: this.mobile,
            popout: this.popout
        };
    },
    width: 0,
    //
    initialize: function () {
        this.width = jQuery('body').width();
        this.priorWidth = this.width;
        this.mobile = this.width < configuration.mobileWidth;
        this.priorMobile = this.mobile;
        this.popout = this.options.popout ? true : false;
        this.filters = new Filters();
        this.programs = new Programs([], {via: 'programs'});
        // Show a spinner while the server is working on a search.
        this.listenTo(this.programs, 'request',
            _.bind(function () {
                this.spin = _.debounce(function () { jQuery('.programs-spinner').removeClass('hidden'); }, 500);
            }, this)
        );
        this.listenTo(this.programs, 'sync',
            _.bind(function () {
                this.onFilterPrograms(this.programFilter);
                if (this.spin) {
                    // avoid showing the spinner AFTER cancellation
                    this.spin.cancel();
                    delete this.spin;
                }
                jQuery('.programs-spinner').addClass('hidden');
            }, this)
        );
        this.listenTo(this.programs, 'change:favorite', _.bind(function (model, options) {
            this.getChildView('programsSidebarFilter').onChangeFavorite();
        }, this));
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.getChildView('programsSummaries').render();
        }, this));
        this.resizeObserver = new ResizeObserver(_.debounce(_.bind(function (observees) {
            // const priorMobile = this.mobile,
            //     priorWidth = this.width;
            this.width = observees[0].contentRect.width;
            this.mobile = this.width < configuration.mobileWidth;
            if (Math.abs(this.width - this.priorWidth) > RESIZE_DELTA && !configuration.ignoreModalsOnResize) {
                if (this.getChildView('programDetails')) {
                    this.getChildView('programDetails').close();
                }
                if (this.getChildView('programsSidebarFilter')) {
                    this.getChildView('programsSidebarFilter').close(_.bind(function () {
                        if (this.mobile !== this.priorMobile) {
                            this.render();
                        }
                    }, this));
                }
                jQuery('[data-dismiss=modal]').trigger('click');
                this.priorWidth = this.width;
                this.priorMobile = this.mobile;
            }
        }, this)));
        this.resizeObserver.observe(jQuery('body')[0]);
    },
    mapNudge: function () {
        this.refreshMarkers();
    },
    onClickButton: function (event) {
        if (this.mobile) {
            // the buttons are no longer located in the sidebar...
            this.getChildView('programsSidebarFilter').onClickButton({action: event.currentTarget.dataset.action});
        }
    },
    onDetailsClosed: function (program) {
        // console.log('programs.onDetailsClosed', program);
        jQuery('#screenReaderAnnouncementsAssertive').text('Program details closed');
        this.getChildView('programsSummaries').focus(program);
    },
    onDisplaySection: function (section) {
        const sections = {
                filters: 'programsSidebarFilter',
                listings: 'programsSummaries',
                map: 'programsMap'
            };
        if (this.section && this.getChildView(sections[this.section])) {
            this.getChildView(sections[this.section]).$el.hide();
        }
        if (this.getChildView(sections[section])) {
            this.getChildView(sections[section]).$el.show();
            if (section === 'map') {
                this.mapNudge();
            }
        }
        if (this.getChildView('programsHeaderFilter')) {
            this.getChildView('programsHeaderFilter').onClickTab({section: section}, true);
        }
        this.section = section;
    },
    onFilterPrograms: function (value) {
        this.getChildView('programsSummaries').filterPrograms(value);
        if (!this.options.popout) {
            this.getChildView('programsSidebarFilter').pseudofilter({group: 'keywords', value: value});
            this.refreshMarkers();
        }
        this.programFilter = value;
    },
    onGroupCleared: function (group) {
        switch (group) {
            case 'keywords':
                this.getChildView('programsHeaderFilter').clearKeywords();
                break;
            case 'sortby':
                this.getChildView('programsHeaderFilter').clearSortby();
                break;
            default:
                break;
        }
    },
    onLatitudeLongitudeUpdated: function (latitudeLongitude) {
        const childView = this.getChildView(latitudeLongitude.source === 'programsMap' ? 'programsSidebarFilter' : 'programsMap');
        if (childView) {
            childView.latitudeLongitude(latitudeLongitude);
        }
    },
    onNextProgram: function (program) {
        // we rely on ProgramDetails view to not call us when at last program...
        this.showProgramDetail(this.programs.at(this.programs.indexOf(program) + 1));
    },
    onPopout: function (action) {
        let url,
            search = [],
            filters = this.urlFilters();
        // @acavan! - what category should we use? may change places.program to places.programDetail and then use places.programs
        // this.channels.analytics.trigger('event', { category: 'places.program', action: 'popout', label: this.model.id });
        if (action === 'popoutPrint') {
            search.push('print');
        }
        if (filters) {
            search.push('filters=' + encodeURIComponent('{{') + jsoncrush.crush(JSON.stringify(filters)) + encodeURIComponent('}}')); //
        }
        if (configuration.embedded) {
            url = 'https://' + user.get('host') + '/places.htm' + (search.length ? '?' + search.join('&') : '')  + '#popoutPrograms';
        } else {
            url = window.location.origin + window.location.pathname + (search.length ? '?' + search.join('&') : '') + '#popoutPrograms';
        }
        if (url.length > 1024) {
            console.log('programs.onPopout - url > 1024 (%s)', url.length);
        }
        window.open(url, '_blank');
    },
    onProgramUpdated: function () {
        // @acavan? 20191003_1517
        console.log('yes! onProgramUpdated is called!');
        this.refreshMarkers(); // @acavan - is this ever called?
    },
    onProgramsFiltered: function (shown) {
        this.getChildView('programsHeaderFilter').count(shown);
        // this.getChildView('programsSidebarFilter').count(shown);
    },
    onPreviousProgram: function (program) {
        // we rely on ProgramDetails view to not call us when at first program...
        this.showProgramDetail(this.programs.at(this.programs.indexOf(program) - 1));
    },
    onRender: function () {
        let match,
            filters;
        if (!this.options.popout) {
            this.showChildView('programsSidebarFilter', new ProgramsSidebarFilter({collection: this.programs, filters: this.filters, mobile: this.mobile}));
        }
        this.showChildView('programsSummaries', new ProgramsSummaries({collection: this.programs, via: 'programs', popout: this.popout}));
        if (!this.options.popout && !configuration.disabledViews.programsMap) {
            this.showChildView('programsMap', new ProgramsMap({collection: this.programs}));
        }
        this.showChildView('programsHeaderFilter', new ProgramsHeaderFilter({collection: this.programs, mobile: this.mobile, popout: this.popout, filters: this.filters}));
        if (!this.options.popout && !configuration.disabledViews.console) {
            this.showChildView('console', new Console());
        }
        if (this.mobile && !this.popout) {
            this.getChildView('programsSummaries').$el.hide();
            if (this.getChildView('programsMap')) {
                this.getChildView('programsMap').$el.hide();
            }
            this.section = 'filters';
        }
        if (this.popout) {
            if (this.getChildView('programsMap')) {
                this.getChildView('programsMap').$el.hide();
            }
            let filters;
            match = window.location.search.match(/filters=%7B%7B(.*)%7D%7D/);
            if (match && match.length > 1) {
                try {
                    filters = JSON.parse(jsoncrush.uncrush(decodeURIComponent(match[1])));
                    this.programs.applyProcessedFilters(filters);
                    if (!filters.selectedOn) {
                        this.getChildView('programsHeaderFilter').filtersList.updateProcessedFilters(filters);
                    } else {
                        this.getChildView('programsHeaderFilter').selectedOn(filters.selectedOn);
                    }
                } catch (error) {
                    console.log('programs.onRender.filters - error (%s)', error);
                }
            }
        }
        this.channels.console.trigger('log', 'programs.initialize: ' + JSON.stringify({width: this.width, mobileWidth: configuration.mobileWidth}));
    },
    onSelectProgram: function (program) {
        this.showProgramDetail(program);
    },
    onSelectProgramId: function (id) {
        this.showProgramDetail(this.programs.get(id));
    },
    onSharePrograms: function () {
        // console.log(this.getChildView('programsSummaries').currentProgramIds());
        const filters = this.urlFilters(),
            url = [
                helpers.popoutUrl(),
                '?filters=',
                encodeURIComponent('{{') + jsoncrush.crush(JSON.stringify(filters)) + encodeURIComponent('}}'),
                '#popoutPrograms'
            ].join(''),
            href = [
                'mailto:?subject=',
                helpers.l10n('placesShareProgramsEmailSubject'),
                '&body=',
                helpers.l10n('placesShareProgramsEmailBody') + '%0D%0A%0D%0A',
                encodeURIComponent(url)
            ].join(''),
            shareDialog = new ShareDialog({label: 'shareProgramsLabel', body: 'shareProgramsBody', href: href, url: url});
    },
    onSortPrograms: function (value) {
        this.getChildView('programsSidebarFilter').pseudofilter({group: 'sortby', value: value});
    },
    onWizardClosed: function () {
        this.getChildView('programsHeaderFilter').showSection('listings');
    },
    urlFilters: function () {
        // return the current filters unless my favorites is selected in which case we send a subset of the filters and the ids of the current programs
        const programFilters = this.programs.currentFilters();
        let programIds, o;
        if (!programFilters.isFavorite) {
            o = programFilters;
        } else {
            programIds = this.getChildView('programsSummaries').currentProgramIds();
            o = _.omitBy({
                programIds: programIds,
                sortby: programFilters.sortby,
                latitude: programFilters.latitude,
                longitude: programFilters.longitude,
                selectedOn: new Date().toISOString()
            }, function (value, property) {
                return value ? false : true;
            });
        }
        // console.log(o);
        return o;
    },
    refreshMarkers: function () {
        if (!configuration.disabledViews.programsMap) {
            this.getChildView('programsMap').refreshMarkers();
        }
    },
    showProgramDetail: function (program) {
        const view = this.getChildView('programDetails');
        if (!view) {
            this.programDetail = this.showChildView('programDetails', new ProgramDetails({model: program, offset: this.programs.indexOf(program) + 1, count: this.programs.length}));
        } else {
            view.newModel({model: program, offset: this.programs.indexOf(program) + 1, count: this.programs.length});
        }
        // request scroll to top
        this.channels.vaultOut.trigger('scrollToTop');
    }
});
